import React, { useState, useEffect } from 'react';
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import TextEvents from 'app/components/TextEvents'
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './HistoryCompaignStyle';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import FilterFormScreen from './FilterFormScreen/FilterFormScreen';
import TableScreen from './Tablescreen/TableScreen';
import * as HistoryActions from 'app/actions/HistoryCampaignActions';

const HistoryCompaignScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { idSubdirection, employeeId } = useSelector((state) => state.Auth.employeeById);
    const [trainingF, setTrainingF] =useState([]);
    const [specialtyF, setSpecialtyF] =useState([]);
    const [communicationF, setCommunicationF] =useState([]);
    const [procedureF, setProcedureF] =useState([]);
    
    const {
        ListTraining
    } = useSelector(state => state.HistoryCampaignReducer)

    useEffect(() => {
        dispatch(HistoryActions.clear());
        dispatch(HistoryActions.getTrainingHC(
            {
                SubDirectionOrigin: idSubdirection,
                idEmployee: employeeId
            }));
       
    }, [dispatch]);

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isRepor={true} header=' Histórico Campaña' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Reportes
                        </Link>
                        <TextEvents
                            text="Reporte Histórico Campaña"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                    <Paper className={classes.rootPaper}>
                        <FilterFormScreen 
                             trainingF={trainingF} setTrainingF={setTrainingF}
                             specialtyF={specialtyF} setSpecialtyF={setSpecialtyF}
                            communicationF={communicationF} setCommunicationF={setCommunicationF}
                            procedureF={procedureF} setProcedureF={setProcedureF}
                        />

                        <TableScreen
                        trainingF={trainingF} setTrainingF={setTrainingF}
                        specialtyF={specialtyF} setSpecialtyF={setSpecialtyF}
                       communicationF={communicationF} setCommunicationF={setCommunicationF}
                       procedureF={procedureF} setProcedureF={setProcedureF}
                        />
                    </Paper>

                </div>
            </div>
        </div>
    )
}

export default HistoryCompaignScreen